import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../Button/Button";
import { fields1, initialHeaders1 } from "../FormComponents/AddSalesBill/AddSalesBill.config";
import { InputsInTable } from "../InputInTable/InputsInTable";
import { calculatePercentage, calculatePercentageFromTaxGroup, getFieldValue, updateFieldInRow } from "./RelatedFunctions";
import { getInterOrIntraStateStatus } from "../../../CommonFunction/CalculateGST/CalculateGST";
interface alldataType {
    Date?: string;
    CashOrDebit?: string;
    Book_Code?: string;
    Bill_No?: number;
    Voucher_Mode?: string;
    Party?: string;
    Tax?: string;
    Tax_Code?: string;
    RCM?: string;
    Tax_Type?: string;
    onErrorsChangeOnTable?: any;
}

export const SalesItemTable = ({ Form_Key, tableData, setTableData, lastModified, setLastModified, setFirstLoad, isFirstLoad, FormData, onErrorsChangeOnTable }) => {
    const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
    const [headers, setheaders] = useState([...initialHeaders1])
    let Party = FormDataFromRedux.MasterData[Form_Key]?.Party;
    const Tax = FormDataFromRedux?.MasterData[Form_Key]?.Tax_Group;
    const dispatch = useDispatch()


    console.log(tableData, isFirstLoad)
    /*
    ****************************************************************************************************************** 
    */


    useEffect(() => {
        // console.log()
        if ((FormData.Party || FormData.RCM || FormData.Tax_Group) && isFirstLoad) {
            updateTaxRateForAllRowsDueToPartyOrRCMChange();
        }
    }, [FormData.Party, FormData.RCM, FormData.Tax_Group]);

    const updateTaxRateForAllRowsDueToPartyOrRCMChange = () => {
        // console.log(alldata.Party, alldata.RCM, "alldata.Party, alldata.RCM")
        const newTableData = { ...tableData };
        Object.keys(newTableData).forEach(rowId => {
            newTableData[rowId] = newTableData[rowId].map(field => {
                if (field.name === "Tax_Rate") {

                    let Tax_Group = FormData.Tax === "Common" ? Tax : FormDataFromRedux.MasterData[Form_Key]?.[rowId]?.["Tax_Group"];
                    const newTaxRate = Tax_Group ? calculateTaxFromGroup(Tax_Group) : ""; // Assuming a function to calculate

                    return { ...field, value: newTaxRate };
                }
                return field;
            });
        });
        // console.log(newTableData, "table11")
        setTableData(newTableData);
    };

    // Define calculateTaxRateBasedOnPartyOrRCM
    const calculateTaxRateBasedOnPartyOrRCM = (HSN_Info) => {

        return calculatePercentage(Party, FormData, HSN_Info); // Modify as needed
    };
    const calculateTaxFromGroup = (Tax_Group) => {
        // console.log(Tax_Group)
        // console.log(Tax_Group.Tax_Rate.Tax_Percentage, Tax_Group)
        return Tax_Group?.Tax_Rate?.Tax_Percentage

    };







    /******************************************************************************************************************** */
    useEffect(() => {
        // console.log(alldata)

        if (FormData.Tax_Code && Tax && FormData.Tax === "Common" && isFirstLoad) {
            // console.log("kkkkkk", Tax)
            const percentage = calculatePercentage(Party, FormData, Tax);
            // console.log(percentage)  
            updateTaxRateAllRows(percentage, tableData);
        }
    }, [FormData.Tax_Code, Form_Key]); // Ensure dependencies are correctly listed

    const updateTaxRateAllRows = (percentage, tableData) => {
        console.log(percentage)
        const newTableData = {};
        Object.keys(tableData).forEach(key => {
            newTableData[key] = tableData[key].map(field => {
                if (field.name === "Tax_Rate") {
                    console.log(field)
                    return { ...field, value: percentage };
                } else {
                    return field;
                }
            });

        });
        // console.log(newTableData, "table12")
        setTableData(newTableData);
    };


    useEffect(() => {
        console.log(isFirstLoad, "check2")
        if (isFirstLoad) {
            console.log(isFirstLoad, "check2")

            updateAllRows();
        }
        updateHeaders()
    }, [FormData.Tax, FormData.Voucher_Mode, FormData.Sales_Account_Selection]); // This will trigger whenever FormData changes
    useEffect(() => {
        // console.log(FormData)
    }, [FormData])

    const updateHeaders = () => {
        let newHeaders = [...initialHeaders1]; // Start with all headers
        if (FormData.Voucher_Mode === "Accounting Entry") {
            // Remove Stock_Item header
            newHeaders = newHeaders.filter(header => header !== "Item Name");
        }
        if (FormData.Tax === "Common") {
            // Remove HSN header
            newHeaders = newHeaders.filter(header => header !== "Tax");
        } else if (FormData.Tax === "Line Itemwise" && !newHeaders.includes("Tax")) {
            // Add Tax header if missing
            const TaxIndex = initialHeaders1.indexOf("Tax");
            newHeaders.splice(TaxIndex, 0, "Tax");
        }
        if (FormData.Sales_Account_Selection === "Common") {
            // Remove HSN header
            newHeaders = newHeaders.filter(header => header !== "Sales A/c");
        } else if (FormData.Sales_Account_Selection === "Line Itemwise" && !newHeaders.includes("Sales A/c")) {
            // Add Tax header if missing
            const TaxIndex = initialHeaders1.indexOf("Sales A/c");
            newHeaders.splice(TaxIndex, 0, "Sales A/c");
        }
        setheaders(newHeaders);
    };

    const updateAllRows = () => {
        const newTableData = {};
        Object.keys(tableData).forEach(key => {
            newTableData[key] = getUpdatedRow(tableData[key], key);
        });
        console.log(newTableData, "table13")
        setTableData(newTableData);
    };

    const getUpdatedRow = (fields, key) => {
        console.log(FormData)
        const isAccountingEntry = FormData.Voucher_Mode === "Accounting Entry";
        const isCommonTax = FormData.Tax === "Common";
        const isLineItemWise = FormData.Tax === "Line Itemwise";
        const isCommonSalesAc = FormData.Sales_Account_Selection === "Common";
        const isLineItemWiseSalesAc = FormData.Sales_Account_Selection === "Line Itemwise";
        const isItemInvoice = FormData.Voucher_Mode === "Item Invoice";
        console.log(isAccountingEntry, isCommonTax, isLineItemWise, isCommonSalesAc, isLineItemWiseSalesAc, isItemInvoice, FormData)
        // console.log(isCommonTax)
        console.log(FormData)
        let updatedFields = fields.filter(field => {
            // Ensure that the object is properly formed with at least a name property
            // console.log(isCommonSalesAc && field.name === "Account", field)
            if (!field.name) return false; // This will filter out malformed objects

            if (isAccountingEntry && field.name === "Stock_Item") {
                return false;
            }
            if (isCommonTax && field.name === "Tax_Group") {
                return false;
            }
            if (isCommonSalesAc && field.name === "Account") {
                return false;
            }
            return true;
        });
        console.log([...updatedFields], "updatedFields", isCommonTax, FormData)
        updatedFields = updatedFields.map(field => {
            if (isCommonTax && (!FormData?.Tax_Group) && (field.name === "Tax_Rate")) {
                return { ...field, value: "" };  // Empty the Tax_Rate and Tax_Amount when Tax is "Common"
            } else if (!field.name) {
                return false; // Filter out malformed objects
            }
            return field;
        }).filter(field => field)
        console.log([...updatedFields], "updatedFields1")



        console.log([...updatedFields], "updatedFields3")

        if (isItemInvoice && !updatedFields.some(field => field.name === "Stock_Item")) {
            const stockItemField = fields1.find(field => field.name === "Stock_Item");
            const stockIndex = fields1.findIndex(field => field.name === "Stock_Item");
            updatedFields.splice(stockIndex, 0, { ...stockItemField, id: Math.random() * 10 });
        }
        console.log([...updatedFields], "updatedFields5")
        // Dynamically add fields if conditions are met
        if (isLineItemWise && !updatedFields.some(field => field.name === "Tax_Group")) {
            // console.log("Hiiiiiiiii")
            const hsnField = fields1.find(field => field.name === "Tax_Group");


            updatedFields.splice(isAccountingEntry ? 1 : 2, 0, { ...hsnField, id: Math.random() * 10 });

        }
        console.log([...updatedFields], "updatedFields2")
        if (isLineItemWiseSalesAc && !updatedFields.some(field => field.name === "Account")) {
            const hsnField = fields1.find(field => field.name === "Account");
            const hsnIndex = fields1.findIndex(field => field.name === "Account");

            updatedFields.splice(isAccountingEntry && isCommonTax ? 3 : isCommonTax || isAccountingEntry ? 4 : 5, 0, { ...hsnField, id: Math.random() * 10 });
            // updatedFields.splice(isAccountingEntry ? 0 : hsnIndex, 0, { ...hsnField, id: Math.random() * 10 });

        }


        if (isLineItemWise) {
            updatedFields.forEach(field => {
                if (field.name === "Stock_Item") {
                    const stockItemDetails = FormDataFromRedux.MasterData[Form_Key]?.[key]?.[field.name];
                    // console.log(stockItemDetails)
                    if (stockItemDetails) {
                        // Update Tax_Code and Tax_Rate
                        const Tax_Group_Index = updatedFields.findIndex(f => f.name === "Tax_Group");
                        // console.log(Tax_Group_Index, updatedFields, "Tax_Group_Index, updatedFields")
                        let intraState = getInterOrIntraStateStatus(Party) ? "Within_State_Tax" : "Outside_State_Tax"
                        if (Tax_Group_Index !== -1) {
                            updatedFields[Tax_Group_Index] = { ...updatedFields[Tax_Group_Index], value: stockItemDetails?.[intraState]?.Tax_Group_Name };
                            setLastModified({ fieldName: "Tax_Group", rowId: key })
                        }

                        let per = calculatePercentageFromTaxGroup(stockItemDetails?.[intraState]);
                        const taxRateIndex = updatedFields.findIndex(f => f.name === "Tax_Rate");
                        if (taxRateIndex !== -1) {
                            updatedFields[taxRateIndex] = { ...updatedFields[taxRateIndex], value: per };
                        }

                        // Dispatch Tax_Code details to Redux
                        dispatch({
                            type: "StoreMasterDataForRow",
                            payload: {
                                formkey: Form_Key,
                                rowId: key,  // Assuming field.value contains the identifier for the row
                                data: { Tax_Group: stockItemDetails?.[intraState] },
                            },
                        });
                    }
                }
            });
        }


        console.log(updatedFields, "updatedFields5")

        return updatedFields;
    };


    const addNewRow = (FormData) => {
        const newRowKey = Math.random() * 10; // Generates a pseudo-random key for the new row
        const isAccountingEntry = FormData.Voucher_Mode === "Accounting Entry";
        const isCommonTax = FormData.Tax === "Common";
        const isCommonSalesAc = FormData.Sales_Account_Selection === "Common";

        let newRow: any = fields1.filter(field => {
            if (isAccountingEntry && field.name === "Stock_Item") {
                return false; // Exclude Stock_Item if it is an accounting entry
            }
            if (isCommonTax && field.name === "Tax_Group") {
                return false; // Exclude Tax_Code if tax is Common
            }
            if (isCommonSalesAc && field.name === "Account") {
                return false; // Exclude Tax_Code if tax is Common
            }

            return true; // Include all other fields
        });

        if (isCommonTax && FormData.Tax_Group) {

            const percentage = calculatePercentageFromTaxGroup(Tax);

            newRow = newRow.map(field => {
                // Set the calculated percentage to Tax_Rate field
                if (field.name === "Tax_Rate") {
                    return { ...field, value: percentage, disabled: true };
                }
                if (field.name === "Account" && !isCommonSalesAc) {
                    return {
                        ...field, variable: {
                            accountType: ["General Account"],
                            // accountGroup: Form_Key == "Purchase_Bill" ? "Purchase" : "Sales",
                        },
                    }
                }
                return field;
            });
        }
        if (!isCommonSalesAc) {
            newRow = newRow.map(field => {
                // Set the calculated percentage to Tax_Rate field

                if (field.name === "Account" && !isCommonSalesAc) {
                    return {
                        ...field, variable: {
                            accountType: ["General Account"],
                            // accountGroup: Form_Key == "Purchase_Bill" ? "Purchase" : "Sales",
                        },
                    }
                }
                return field;
            });
        }

        // console.log(newRow, "table14");
        setTableData(prevTableData => ({
            ...prevTableData,
            [newRowKey]: newRow,
        }));
    };


    const handleInputChange = async (evt, id, rowId) => {
        // console.log(evt, id, rowId)
        setFirstLoad(true)
        const fieldName = evt.target.name;
        let updatedData = updateFieldInRow(tableData[rowId], id, evt.target.value);

        const updateField = (name, value) => {
            return updatedData.map((el) => (el.name === name ? { ...el, value } : el));
        };

        // Common function to update Tax Rates and Amounts
        const updateTaxAndAmount = (Tax_group_Details) => {

            // let per = calculatePercentageFromTaxGroup(Tax_group_Details);
            // console.log(per)
            updatedData = updateField("Tax_Rate", Tax_group_Details?.Tax_Rate?.Tax_Percentage);
            // console.log(updatedData)
            // Recalculate Tax_Amount if Amount is available
            // const amount = getFieldValue(updatedData, "Amount");
            // if (amount) {
            //     updatedData = updateField("Tax_Amount", calculateTax(amount, per));
            // }
        };

        if (fieldName.includes("Tax_Group")) {
            const Tax_Group_Details = FormDataFromRedux.MasterData[Form_Key]?.[rowId]?.[evt.target.name];
            // console.log(Tax_Group_Details);
            if (Tax_Group_Details) {
                updateTaxAndAmount(Tax_Group_Details);
            }
        }

        if (fieldName === "Quantity" || fieldName === "Item_Value") {
            const quantity = getFieldValue(updatedData, "Quantity") || 0;
            const itemValue = getFieldValue(updatedData, "Item_Value") || 0;

            const newAmount = (parseFloat(quantity) * parseFloat(itemValue)).toFixed(2);
            updatedData = updateField("Amount", newAmount.toString());



        }
        console.log(fieldName)
        if (fieldName === "Stock_Item") {
            const stockItemDetails = FormDataFromRedux.MasterData[Form_Key]?.[rowId]?.[evt.target.name];
            const currentHSN = getFieldValue(updatedData, "Tax_Code");
            // console.log(updatedData, currentHSN, stockItemDetails.Tax_Code.Tax_Code, "HSNHSNS")
            console.log(stockItemDetails)
            if (stockItemDetails) {
                console.log(stockItemDetails, currentHSN)

                if (currentHSN !== stockItemDetails?.Tax_Code?.Tax_Code) {  // Check if Tax_Code would actually change
                    updatedData = updateField("Tax_Code", stockItemDetails?.Tax_Code?.Tax_Code);
                    dispatch({
                        type: "StoreMasterDataForRow",
                        payload: {
                            formkey: Form_Key,
                            rowId: rowId,
                            data: {
                                Tax_Code: stockItemDetails?.Tax_Code,
                            },
                        },
                    });
                }


                const intra = getInterOrIntraStateStatus(Party) ? "Within_State_Tax" : "Outside_State_Tax"
                // console.log(intra, stockItemDetails, stockItemDetails[intra], fieldName)
                if (stockItemDetails && stockItemDetails[intra] && FormData.Tax !== "Common") {
                    const currentHSN = getFieldValue(updatedData, "Tax_Group");
                    // console.log(stockItemDetails[intra]?.Tax_Rate?.Tax_Percentage)
                    if (currentHSN !== stockItemDetails[intra]?.Tax_Rate?.Tax_Percentage) {  // Check if Tax_Code would actually change
                        updatedData = updateField("Tax_Group", stockItemDetails[intra]?.Tax_Group_Name);
                        dispatch({
                            type: "StoreMasterDataForRow",
                            payload: {
                                formkey: Form_Key,
                                rowId: rowId,
                                data: {
                                    Tax_Group: stockItemDetails[intra],
                                },
                            },
                        });
                        // console.log(stockItemDetails)
                        updateTaxAndAmount(stockItemDetails[intra]
                        );
                    }
                }
                let acc = Form_Key == "Purchase_Bill" || Form_Key == "Credit_Note" ? stockItemDetails?.Purchase_A_C_Data : stockItemDetails?.Sales_A_C_Data
                console.log(acc)
                if (stockItemDetails && acc) {
                    const currentAccount = getFieldValue(updatedData, "Account");
                    // console.log(updatedData, currentAccount, acc.Search_Value)
                    console.log(currentAccount, acc)
                    if (currentAccount !== acc.Search_Value) {  // Check if Account_Name would actually change
                        updatedData = updateField("Account", acc.Search_Value);
                        dispatch({
                            type: "StoreMasterDataForRow",
                            payload: {
                                formkey: Form_Key,
                                rowId: rowId,
                                data: {
                                    Account: {
                                        ...acc,
                                        Account_Balance_Id: acc?._id,

                                    }
                                },
                            },
                        });

                    }
                }
                updatedData = updateField("Item_Value", Form_Key === "Purchase_Bill" || Form_Key == "Credit_Note" ? stockItemDetails.Purchase_Price || 0 : stockItemDetails.Selling_Price || 0);
                const quantity = getFieldValue(updatedData, "Quantity") || 0;
                const itemValue = Form_Key === "Purchase_Bill" || Form_Key == "Credit_Note" ? stockItemDetails.Purchase_Price || 0 : stockItemDetails.Selling_Price || 0;

                const newAmount = (parseFloat(quantity) * parseFloat(itemValue)).toFixed(2);
                updatedData = updateField("Amount", newAmount.toString());
            }
        }

        // Log updated data structure for debugging
        // console.log({ [rowId]: updatedData }, "table15");

        setTableData((prevData) => ({
            ...prevData,
            [rowId]: updatedData,
        }));
        setLastModified({ fieldName, rowId });
    };


    const HandleDeleteRef = (rowId) => {
        const newData = { ...tableData };
        delete newData[rowId];
        setTableData(newData); // ✅ fresh object
        setLastModified({ fieldName: "HSN", rowId: "" });
    };
    // console.log(tableData)
    return <div className="ItemInvoiceTable  sales-bill-table">
        <InputsInTable
            title={"CreditNoteData"}
            headers={headers}
            data={tableData}
            HandleInputChange={handleInputChange}
            handleOnFocus={() => { }}
            handleDelete={HandleDeleteRef}
            formkey={Form_Key}
            footerData={{ 'Quantity': 0, 'Amount': 0 }}
            onErrorsChange={onErrorsChangeOnTable}
        />
        <Button text="Add" name="modalbutton" action={() => addNewRow(FormData)} />

    </div>
}